import { Tag } from "@chakra-ui/react";
import moment from "moment";
import colors from "core/resources/theme/colors";
import { OrigemContaEnum } from "core/features/cobranca/typings";
interface TagRowCobrancaProps {
  dataPosicao: string;
  dataVencimento?: string;
  diasEmAtraso?: number;
  origemContaId?: OrigemContaEnum;
  semIndiceMesDataPosicao?: boolean;
}

export default function TagRowCobranca({
  dataPosicao,
  dataVencimento,
  diasEmAtraso,
  origemContaId,
  semIndiceMesDataPosicao,
}: TagRowCobrancaProps) {
  return (
    <>
      {dataVencimento ? (
        <Tag
          rounded={15}
          bg="white"
          fontWeight="light"
          fontSize="11px"
          color={colors.black700}
          borderWidth={1}
          borderColor={colors.black200}
        >
          Vencimento {moment(dataVencimento).format("DD/MM/YYYY")}
        </Tag>
      ) : null}

      {diasEmAtraso && diasEmAtraso > 0 ? (
        <Tag
          rounded={15}
          bg={colors.red500}
          fontSize="11px"
          color={colors.white}
          borderWidth={1}
          borderColor={colors.red1000}
        >
          {diasEmAtraso} dias em atraso
        </Tag>
      ) : null}

      {origemContaId === OrigemContaEnum.Acordo ? (
        <Tag
          rounded={15}
          bg={colors.green500}
          fontSize="11px"
          color={colors.white}
          borderWidth={1}
          borderColor={colors.green1000}
        >
          Acordo
        </Tag>
      ) : null}

      {semIndiceMesDataPosicao ? (
        <Tag
          rounded={15}
          bg={colors.red500}
          fontSize="11px"
          color={colors.white}
          borderWidth={1}
          borderColor={colors.red500}
        >
          Índice não disponível para {moment(dataPosicao).format("MMMM/YYYY")}
        </Tag>
      ) : null}
    </>
  );
}
